import axios, { AxiosRequestConfig } from "axios";

export const API_URL = process.env.REACT_APP_API_URL;
export const audience = process.env.REACT_APP_AUTH0_API_AUDIENCE;
export const deploymentId = process.env.REACT_APP_DEPLOYMENT_ID;
export const deploymentURL = process.env.REACT_APP_DEPLOYMENT_URL;
// const getApiUrl = async () => {
//   const { data: config } = await axios.get("/config.json");
//   return `${config.apiUrl}`;
// };

export const apiClient = async (configs: AxiosRequestConfig): Promise<any> => {
  const token = await tokenUtil.getAccessTokenSilently()({ audience });
  const userDetails = await tokenUtil.getUserDetails();
  let finalUrl = API_URL;
  if (deploymentId) {
    finalUrl = deploymentURL;
  }
  return axios({
    ...configs,
    headers: {
      ...configs.headers,
      name: userDetails && userDetails?.name,
      email: userDetails && userDetails?.email,
      Authorization: `Bearer ${token}`,
    },
    baseURL: `${finalUrl}/admin`,
  });
};

let getAccessTokenSilently: Function = () => {};
let getUserDetails: any = () => {};

export const tokenUtil = {
  getAccessTokenSilently: () => getAccessTokenSilently,
  setAccessTokenSilently: (func: Function) => (getAccessTokenSilently = func),
  getUserDetails: () => getUserDetails,
  setUserDetails: (users: any) => (getUserDetails = users),
};
